import { IdentityService } from "../IdentityService";
import { SplashScreen } from '../../../../common/components/splash-screen/SplashScreen';
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

interface IIdentityActionProps {

    exec: (svc : IdentityService, calledFromUrl: string | undefined | null) => void;
}

export function IdentityAction(props: IIdentityActionProps) {

    const [searchParams] = useSearchParams ();
    // MSAL redirect calls must run exactly once per mount: React StrictMode (dev) re-runs effects,
    // and a second loginRedirect/logoutRedirect throws "interaction_in_progress".
    const started = useRef(false);


    useEffect(() => {
        if (started.current) return;
        started.current = true;
        props.exec(IdentityService.Global,searchParams.get("url"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);


    return (
        <SplashScreen/>
    );

}
